module.exports = __webpack_public_path__ + "img/ion_document.df42a89b.svg";